import Logo from 'assets/icons/login/logo.svg';

const LoginBrand: React.FC = () => {
  return (
    <div className="flex flex-col gap-2 items-center">
      <div className="flex h-20 w-42.5 items-center justify-center">
        <img src={Logo} alt="نما" />
      </div>
      <p className="text-body-sm-emphasis text-gray-10">به نما خوش‌آمدید</p>
      <p className="text-body-xs-emphasis text-gray-10">
        دستیار هوشمند نما برای افزایش فروش در کنار شما است
      </p>
    </div>
  );
};

export default LoginBrand;
